import React from "react";

import { StimulusElement } from "@examspark/types";

import RichContentTtsDisplay from "./common/RichContentTtsDisplay";

interface Props {
  data: StimulusElement;
}

const Stimulus: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <>
      <div className="item-player-element item-player-stimulus">
        {props.data?.content?.prompt?.body && (
          <RichContentTtsDisplay content={props.data.content.prompt.body} />
        )}
      </div>
    </>
  );
};

export default Stimulus;
